import React from 'react';
import { Link } from '@tanstack/react-router';

const MemoryFooter: React.FC = () => {
  return (
    <div className="memory-footer">
      <hr />
      <div className="memory-footer-content wa-stack wa-gap-2xs wa-justify-content-center">
        <Link to="/">
          <img src="/images/lgcy-logo.png" alt="LGCY" className="memory-footer-logo" />
        </Link>
        <p className="subtitle center">
          Preserve the moments that matter, now and long after you're gone.
        </p>
        <p className="subtitle center">
          <Link to="/memories/create">Start your own LGCY — it's free</Link>
        </p>
      </div>
    </div>
  );
}

export default MemoryFooter;
